import React, { useRef, useState } from "react";
import AppLayout, {
  AppLayoutProps,
} from "@amzn/awsui-components-console/app-layout";
import { NonCancelableCustomEvent } from "@amzn/awsui-components-console";
import { Navigation } from "src/pages/commons";
import { URLS } from "src/components/constants/appConstants";
import { appLayoutAriaLabels } from "src/i18n-strings/app-layout";
import { ToolsContent } from "src/pages/bartAuditHistory/components/common-components";
import AppBARTAuditHistory from "src/components/bartAuditHistoryPage/bart-audit-history-page";

export function BartAuditHistory() {
  const [navigationOpen, setNavigationOpen] = React.useState(false);
  const appLayout = useRef<AppLayoutProps.Ref>(null);
  const [toolsOpen, setToolsOpen] = useState(false);
  const loadPanelFn = () => {
    setToolsOpen(true);
    appLayout.current?.focusToolsClose();
  };

  const onToolsChangeFn = ({
    detail,
  }: NonCancelableCustomEvent<AppLayoutProps.ChangeDetail>) => {
    setToolsOpen(detail.open);
  };
  return (
    <AppLayout
      disableContentPaddings
      content={<AppBARTAuditHistory />}
      navigation={<Navigation activeHref={URLS.BART_AUDIT_HISTORY} />}
      navigationOpen={navigationOpen}
      onNavigationChange={({ detail }) => setNavigationOpen(detail.open)}
      tools={<ToolsContent />}
      toolsOpen={toolsOpen}
      onToolsChange={onToolsChangeFn}
      ariaLabels={appLayoutAriaLabels}
    />
  );
}
